export default function loggedIn({ next, store }) {
  if (store.getters.userLoggedIn) {
    return next();
  } else {
    return next({
      path: "/login",
    });
  }
}
